import supplierImage from '../../assets/images/supplier/supplier.png';
import tickIcon from '../../assets/images/supplier/tick.png';

const SupplierContent = () => {
  return (
    <div className="md:w-1/2 ">
      <h2 className="text-3xl font-bold mb-6">Suppliers</h2>
      <p className="mb-6">
        Grace Super Market has rapidly grown over the past couple of years and is making its mark as a force to reckon with in the retail segment.
      </p>
      <p className="mb-6">
        If you are a manufacturer or supplier in any of the following (but not limited to) segments, then do connect with us to retail your products at our stores.
      </p>
      <ul className="space-y-4 mb-8">
        <li className="flex items-start">
          <img src={tickIcon} alt="tick" className="w-5 h-5 mt-1 mr-3 flex-shrink-0" />
          <span>FMCG - Processed foods, beverages, toiletries, candies, cosmetics, health and personal care products, household items, over-the-counter drugs, dry goods and other consumables.</span>
        </li>
        <li className="flex items-start">
          <img src={tickIcon} alt="tick" className="w-5 h-5 mt-1 mr-3 flex-shrink-0" />
          <span>General Merchandise - Shoes, home appliances, beauty products, impulse purchase products.</span>
        </li>
        <li className="flex items-start">
          <img src={tickIcon} alt="tick" className="w-5 h-5 mt-1 mr-3 flex-shrink-0" />
          <span>Birthday And Anniversary Party Products - cake, invitations, balloons, tables and chairs</span>
        </li>
      </ul>
      <p className="text-green-700 font-medium mb-4">
        Grace Super Market is known to build long term relationships with its suppliers and business associates.
      </p>
      <p className="text-green-700 font-medium mb-8">
        Any other category products your welcome to connect with us.
      </p>
      <img src={supplierImage} alt="Supplier Partnership" className="w-full max-w-md" />
    </div>
  );
};

export default SupplierContent;